import React from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import api, { formatApiErrorDetail } from "../../lib/api";
import { IMAGES } from "../../lib/images";

export default function Newsletter() {
  const [email, setEmail] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message || "Subscribed!");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not subscribe.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      className="relative overflow-hidden adire-bg grain-overlay"
      data-testid="newsletter-section"
    >
      <div
        className="absolute inset-0 opacity-[0.08] bg-cover bg-center"
        style={{ backgroundImage: `url(${IMAGES.textileGeometric})` }}
        aria-hidden
      />
      <div className="relative max-w-5xl mx-auto px-6 py-24 text-center">
        <p className="uppercase tracking-[0.25em] text-xs text-gold-soft mb-5">
          Join the Community
        </p>
        <h2 className="font-serif text-4xl md:text-5xl text-cream leading-tight mb-5">
          Preserving Heritage. Sharing Knowledge.
        </h2>
        <p className="text-cream/70 max-w-2xl mx-auto mb-10 text-lg">
          Receive new articles, festival stories, and cultural insights from ÀsÀNigHT
          Worldwide — delivered with care, rooted in authenticity.
        </p>
        <form
          onSubmit={submit}
          className="flex flex-col sm:flex-row gap-3 max-w-xl mx-auto"
        >
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            data-testid="newsletter-email-input"
            className="flex-1 bg-cream/5 border border-cream/20 text-cream placeholder:text-cream/40 rounded-md px-5 py-4 outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="newsletter-submit-button"
            className="inline-flex items-center justify-center gap-2 bg-gold text-night font-semibold px-7 py-4 rounded-md hover:bg-gold-light transition-colors disabled:opacity-60"
          >
            {loading ? "Sending..." : "Subscribe"}
            <Send className="w-4 h-4" />
          </button>
        </form>
      </div>
    </section>
  );
}
